import { getNames } from 'country-list';
import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'; // Alternative default style
import "./ContactComponent.css";

const ContactComponent = () => {
    const countries = getNames();

    const formRef = useRef();

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        city: "",
        state: "",
        country: "United Arab Emirates",
        purpose: "Sales",
        message: ""
    });
    const [formStatus, setFormStatus] = useState(false);
    const [formSuccess, setFormSuccess] = useState(false);

    const sendContactEmail = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/send-contact-form`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    name: formData.name,
                    email: formData.email,
                    phone: formData.phone,
                    city: formData.city,
                    state: formData.state,
                    country: formData.country,
                    purpose: formData.purpose,
                    message: formData.message
                })
            });

            const result = await response.json();
            if (result.success) {
                setFormSuccess(true);
                setFormStatus(true);
                setTimeout(() => setFormStatus(false), 5000);
                setFormData({
                    name: "",
                    email: "",
                    phone: "",
                    city: "",
                    state: "",
                    country: "United Arab Emirates",
                    purpose: "Sales",
                    message: ""
                });
            } else {
                setFormSuccess(false);
                setFormStatus(true);
                setTimeout(() => setFormStatus(false), 5000);
            }
        } catch (err) {
            console.error(err);
            setFormSuccess(false);
            setFormStatus(true);
            setTimeout(() => setFormStatus(false), 5000);
        }
    };

    const purposes = [
        "Sales",
        "Other"
    ];

    return (
        <>
            <div className='contact-page-container'>
                <div className="Page-Main_Dec">
                    <h1 className="Page-title_LowerCase">Contact</h1>
                    <nav className="contact-breadcrumb" style={{ margin: '4px 0 20px 0', fontSize: '14px', color: '#555', textAlign: 'left' }}>
                        <Link to="/" style={{ color: '#333', textDecoration: 'underline' }}>Home</Link>
                        <span style={{ color: '#777', margin: '0 6px' }}>&gt;</span>
                        <span>Contact</span>
                    </nav>
                </div>
                <div className="contact-pg-content">
                    <div className="contact-row">
                        {/* Column 1: UK-Europe */}
                        <div className="contact-column">
                            <h3>UK-Europe</h3>
                            <p>
                                <strong>UK Office :</strong><br />
                                Callistus UK Ltd.<br />
                                Magnolia House, Spring Villa Park, 11 Spring<br />
                                Villa Road<br />
                                Edgware HA8 7EB<br />
                                England<br />
                                <a href="mailto:sales@callistusblinds.com">sales@callistusblinds.com</a><br />
                                Mobile: <a href="tel: +44 772 361 9926"> +44 772 361 9926</a><br />
                            </p>
                            <p>
                                <strong>United States</strong><br />
                                <a href="mailto:sales@callistusblinds.com">sales@callistusblinds.com</a><br />
                                Mobile: <a href="tel:+16464665719">+1(646) 466 5719</a>
                            </p>
                        </div>

                        {/* Column 2: GCC */}
                        <div className="contact-column">
                            <h3>GCC</h3>
                            <p>
                                <strong>Dubai Factory :</strong><br />
                                Callistus Blinds Middle East FZE<br />
                                Q4-109,110, SAIF Zone,<br />
                                Sharjah,<br />
                                UAE<br />
                                P.O. Box 120723<br />
                                <a href="mailto:sales@callistusblinds.ae">sales@callistusblinds.ae</a><br />
                                Mobile: <a href="tel:+971586452901">+971 58 645 2901</a>
                            </p>
                        </div>

                        {/* Column 3: India */}
                        <div className="contact-column">
                            <h3>India</h3>
                            <p>
                                <strong>India Factory :</strong><br />
                                Plot No. 210-211<br />
                                G. I. D. C Phase-II, Dared,<br />
                                Jamnagar - 361004<br />
                                Gujarat<br />
                                INDIA<br />
                                <a href="mailto:sales@callistusblinds.com">sales@callistusblinds.com</a><br />
                                <a href="mailto:info@callistusblinds.com">info@callistusblinds.com</a>
                            </p>
                        </div>
                    </div>

                    {/* Contact Form Section */}
                    <div className="contact-form-section">
                        <h3>Connect To Our Consultant</h3>
                        <form className="contact-form" ref={formRef} onSubmit={sendContactEmail}>
                            <input type="hidden" name="form_type" value="Contact" />

                            {/* Name */}
                            <div className="form-group full-width">
                                <label htmlFor="name">Name*</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    placeholder=""
                                    required
                                    value={formData.name}
                                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                />
                            </div>

                            {/* Email + Phone */}
                            <div className="form-row">
                                <div className="form-group half-width">
                                    <label htmlFor="email">Email*</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder=""
                                        required
                                        value={formData.email}
                                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                    />
                                </div>
                                <div className="form-group half-width">
                                    <label htmlFor="phone">Mobile*</label>
                                    <PhoneInput
                                        country={"ae"}
                                        enableSearch={true}
                                        value={formData.phone}
                                        onChange={(phone) => setFormData({ ...formData, phone })}
                                        placeholder=""
                                        className="Pnum"
                                        inputProps={{
                                            name: "phone",
                                            required: true
                                        }}
                                    />
                                </div>
                            </div>

                            {/* City + State */}
                            <div className="form-row">
                                <div className="form-group half-width">
                                    <label htmlFor="city">City / Area</label>
                                    <input
                                        type="text"
                                        id="city"
                                        name="city"
                                        placeholder=""
                                        value={formData.city}
                                        onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                                    />
                                </div>
                                <div className="form-group half-width">
                                    <label htmlFor="state">State</label>
                                    <input
                                        type="text"
                                        id="state"
                                        name="state"
                                        placeholder=""
                                        value={formData.state}
                                        onChange={(e) => setFormData({ ...formData, state: e.target.value })}
                                    />
                                </div>
                            </div>

                            {/* Country + Purpose */}
                            <div className="form-row">
                                <div className="form-group half-width">
                                    <label htmlFor="country">Country</label>
                                    <select
                                        id="country"
                                        name="country"
                                        value={formData.country}
                                        onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                                    >
                                        {countries.map((country, idx) => (
                                            <option value={country} key={idx}>{country}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group half-width">
                                    <label htmlFor="purpose">Purpose</label>
                                    <select
                                        id="purpose"
                                        name="purpose"
                                        value={formData.purpose}
                                        onChange={(e) => setFormData({ ...formData, purpose: e.target.value })}
                                    >
                                        {purposes.map((purpose, index) => (
                                            <option key={index} value={purpose}>{purpose}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* Message */}
                            <div className="form-group full-width message-field">
                                <label htmlFor="message">Message</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    placeholder=""
                                    cols={40}
                                    rows={5}
                                    value={formData.message}
                                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                                ></textarea>
                            </div>
                            <div className="form-notify">
                                {formStatus && formSuccess && (
                                    <p className="notify-text success">Your form has been submitted successfully!</p>
                                )}
                                {formStatus && !formSuccess && (
                                    <p className="notify-text error">There was an error submitting your form. Please try again.</p>
                                )}
                            </div>

                            <button type="submit" className="submit-btn">Submit</button>
                        </form>

                    </div>
                </div>
            </div>
        </>
    );
};

export default ContactComponent;